import React from "react";
import { RequestForm, RequestFormContext } from "./RequestForm";
import {
  AirportDestination,
  AirportOrigin,
  ConsigneeAddress,
  ContactForm,
  Delivery,
  EndScreen,
  Pickup,
  RegularShipments,
  ShipmentDate,
  ShipmentIntervals,
  ShipmentDetails,
  ShipperAddress,
  SpecialRequest,
  TransitTime,
} from "./Steps";

export interface RequestFormContentProps {
  step: number;
}

export type Contents = {
  [key: number]: JSX.Element;
};

export const RequestFormContent = (
  props: RequestFormContentProps
): JSX.Element => {
  const formContext: RequestForm = React.useContext(RequestFormContext);

  const handleNextBack = {
    handleNext: formContext.handleNext,
    handleBack: formContext.handleBack,
  };

  const handleNextBackChange = {
    ...handleNextBack,
    handleChange: formContext.handleChange,
  };

  const handleNextBackChangeOrder = {
    ...handleNextBackChange,
    order: formContext.state.order,
  };

  const handleNextBackOrder = {
    ...handleNextBack,
    order: formContext.state.order,
  };

  const contents: Contents = {
    0: (
      <RegularShipments
        handleNext={formContext.handleNext}
        handleChange={formContext.handleChange}
        contact={formContext.state.order.contact}
        setLoggedIn={formContext.setLoggedIn}
        order={formContext.state.order}
      />
    ),
    1: (
      <ShipmentDetails
        {...handleNextBackChangeOrder}
        addItem={formContext.addItem}
        removeItem={formContext.removeItem}
        handleItemChange={formContext.handleItemChange}
      />
    ),
    2: (
      <ShipmentIntervals
        {...handleNextBackChange}
        order={formContext.state.order}
      />
    ),
    3: (
      <TransitTime
        {...handleNextBackChangeOrder}
        order={formContext.state.order}
      />
    ),
    4: <ShipmentDate {...handleNextBackChangeOrder} />,
    5: <SpecialRequest {...handleNextBackChangeOrder} />,
    6: <Pickup {...handleNextBackChange} order={formContext.state.order} />,
    7: <AirportOrigin {...handleNextBackChangeOrder} />,
    8: (
      <ShipperAddress
        {...handleNextBackOrder}
        addItem={formContext.addItem}
        // removeShipper={this.removeShipper}
        shipperAddresses={formContext.state.order.shipperaddresses}
        handleItemChange={formContext.handleItemChange}
        order={formContext.state.order}
      />
    ),
    9: (
      <Delivery
        {...handleNextBackChangeOrder}
        order={formContext.state.order}
      />
    ),
    10: (
      <AirportDestination
        {...handleNextBackChangeOrder}
        loggedIn={formContext.state.loggedIn}
      />
    ),
    11: (
      <ConsigneeAddress
        {...handleNextBackChangeOrder}
        // handleShipper={this.handleShipper}
        consigneeAddresses={formContext.state.order.consigneeaddresses}
        handleItemChange={formContext.handleItemChange}
        addItem={formContext.addItem}
        loggedIn={formContext.state.loggedIn}
      />
    ),
    12: (
      <ContactForm
        {...handleNextBackOrder}
        handleContact={formContext.handleContact}
        handleCheck={formContext.handleCheck}
      />
    ),
    13: (
      <EndScreen
        {...handleNextBack}
        contact={formContext.state.order.contact}
        loggedIn={formContext.state.loggedIn}
        submitOrder={formContext.submitOrder}
      />
    ),
  };

  return contents[props.step] ?? <></>;
};
